import { RiMenuFold2Line, RiMenuUnfold2Line } from "react-icons/ri";

const SidebarHeader = ({
  collapsed,
  toggleCollapse,
}: {
  collapsed: boolean;
  toggleCollapse: () => void;
}) => {
  return (
    <div
      className={`flex items-center justify-between p-2 ${
        collapsed ? "justify-center" : ""
      }`}
    >
      {!collapsed && (
        <h1 className="text-2xl font-semibold text-base-content ml-1">
          Gamgee
        </h1>
      )}
      <button
        onClick={toggleCollapse}
        className="btn btn-ghost btn-square"
        title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
      >
        {collapsed ? (
          <RiMenuFold2Line size={18} />
        ) : (
          <RiMenuUnfold2Line size={18} />
        )}
      </button>
    </div>
  );
};

export default SidebarHeader;
